(function() {
  'use strict';

  var CONFIG = {
    STEP_TOTAL: 5,
    CRM_API: 'https://app.jeugonflablequebec.ca/index.php/shopify_calendar_api/available_products',
    DATE_MIN_DAYS: 2,
    MAX_PER_TIER: 3
  };

  var state = {
    currentStep: 1,
    selectedEvent: null,
    selectedAge: null,
    selectedVariants: [],
    selectedProducts: [],
    selectedForfait: null,
    catalog: [],
    availableCrmIds: null,
    catalogCrmIds: null,
    availabilityLoaded: false
  };

  // ── Keyword maps ─────────────────────────────────────────────────
  var CONSUMABLE_KW = [
    'boisseur', 'maïs soufflé', 'mais soufflé',
    'hot-dog', 'hot dog', 'cônes à barbe', 'cones a barbe', 'sachet de',
    'sac de sable', 'sac de balle', 'consommable', 'sucre à', 'sucre a',
    'solution moussante', 'nettoyage', 'remplissage', 'essence ', 'liquide moussant',
    'sac de service', 'base de slush', 'popcorn, sachet', 'sachet'
  ];

  var MACHINE_KW = [
    'machine à', 'machine a ', 'jukebox', 'karaoké', 'karaoke',
    'génératrice', 'generatrice', 'canon à mousse', 'canon a mousse',
    'bonhomme dansant', 'air dancer'
  ];
  var FOOD_MACHINE_KW = [
    'barbe à papa', 'barbe a papa', 'popcorn', 'maïs soufflé', 'mais soufflé',
    'slush', 'hot-dog', 'hot dog', 'camion crème', 'camion creme', 'combo tropical'
  ];

  var ACCESSORY_KW = [
    'rallonge', 'tapis de', 'parachute', 'électrique', 'electrique'
  ];

  var SALE_KW = ['à vendre', 'a vendre', 'usagé', 'usagee', 'usage -'];

  var VARIANT_KW = {
    chateau:    ['château', 'chateau', 'castle', 'bouncer', 'licorne', 'mickey', 'reine des neiges', 'roi lion', 'barbie', 'batman', 'bob l\'éponge', 'pat patrouille', 'spiderman'],
    glissade:   ['glissade', 'slide', 'toboggan', 'arc-en-ciel', 'camouflage', 'bootcamp', 'radio active', 'élastique', 'elastique', 'course et glissade', 'challenge'],
    parcours:   ['parcours', 'obstacle', 'course', 'bootcamp', 'atomique', 'bonbons multiact'],
    interactif: ['interactif', 'sport', 'joute', 'jousting', 'basketball', 'football', 'soccer', 'boxe', 'sumo', 'adresse', 'gladiateur', 'arène', 'combat', 'lutte'],
    aquatique:  ['aquatique', 'splash', 'piscine', 'hawaï', 'hawaii', 'flamant rose', 'dauphin'],
    combo:      ['combo', 'tout-en-un', 'tout en un', '2-en-1', '2 en 1', 'multi', 'caserne', 'camion']
  };

  var els = {};

  function init() {
    cacheElements();
    bindEvents();
    initDateMin();
    loadCatalog();
    setupAutocomplete();
    if (els.requestToken && !els.requestToken.value) {
      els.requestToken.value = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : String(Date.now()) + '-' + Math.random().toString(16).slice(2);
    }
  }

  function cacheElements() {
    els.hero          = document.getElementById('jgq-ai-hero');
    els.heroStart     = document.getElementById('jgq-ai-hero-start');
    els.wizard        = document.getElementById('jgq-ai-wizard');
    els.form          = document.getElementById('jgq-ai-quote-form');
    els.produitsJson  = document.getElementById('jgq-ai-produits-json');
    els.requestToken  = document.getElementById('jgq-ai-request-token');
    els.progressBar   = document.getElementById('jgq-ai-progress-bar');
    els.stepIndicator = document.getElementById('jgq-ai-step-indicator');
    els.assistantText = document.getElementById('jgq-ai-assistant-text');
    els.sticky        = document.getElementById('jgq-ai-sticky-cta');
    els.btnPrev       = document.getElementById('jgq-ai-nav-prev');
    els.btnNext       = document.getElementById('jgq-ai-nav-next');
    els.error         = document.getElementById('jgq-quote-form-error');
    // Step 1
    els.typeInput       = document.getElementById('jgq-ai-type-evenement');
    els.ageInput        = document.getElementById('jgq-ai-tranche-age');
    els.dateInput       = document.getElementById('jgq-ai-date');
    els.dateFinVisible  = document.getElementById('jgq-ai-date-fin-visible');
    els.dateFinInput    = document.getElementById('jgq-ai-date-fin');
    els.adresseInput    = document.getElementById('jgq-ai-adresse');
    els.codePostalInput = document.getElementById('jgq-ai-code-postal');
    els.heureDebut      = document.getElementById('jgq-ai-heure-debut');
    els.heureFin        = document.getElementById('jgq-ai-heure-fin');
    // Step 2
    els.typesJeuxInput  = document.getElementById('jgq-ai-types-jeux');
    // Step 3
    els.recLoading      = document.getElementById('jgq-ai-rec-loading');
    els.recLoadingText  = document.getElementById('jgq-ai-rec-loading-text');
    els.recLoadingSub   = document.getElementById('jgq-ai-rec-loading-sub');
    els.dispoBanner     = document.getElementById('jgq-ai-dispo-banner');
    els.recContainer    = document.getElementById('jgq-ai-recommendations');
    els.recBest         = document.getElementById('jgq-ai-rec-best');
    els.recEconomic     = document.getElementById('jgq-ai-rec-economic');
    els.recPremium      = document.getElementById('jgq-ai-rec-premium');
    els.recMachines     = document.getElementById('jgq-ai-rec-machines');
    els.recSecPremium   = document.getElementById('jgq-ai-rec-section-premium');
    els.recSecBest      = document.getElementById('jgq-ai-rec-section-best');
    els.recSecEconomic  = document.getElementById('jgq-ai-rec-section-economic');
    els.recSecMachines  = document.getElementById('jgq-ai-rec-section-machines');
    els.recForfaits     = document.getElementById('jgq-ai-rec-forfaits');
    els.recSecForfaits  = document.getElementById('jgq-ai-rec-section-forfaits');
    els.forfaitInput    = document.getElementById('jgq-ai-forfait-input');
    els.participantsEarly = document.getElementById('jgq-ai-participants-early');
    els.participants    = document.getElementById('jgq-ai-participants');
    els.catalogGrid     = document.getElementById('jgq-ai-catalog-grid');
    els.catalogSearch   = document.getElementById('jgq-ai-catalog-search');
    els.selectedPanel   = document.getElementById('jgq-ai-selected-panel');
    els.selectedTags    = document.getElementById('jgq-ai-selected-tags');
    els.produitsInput   = document.getElementById('jgq-ai-produits-input');
    // Step 4
    els.servicesInput   = document.getElementById('jgq-ai-services');
    els.surfaceInput    = document.getElementById('jgq-ai-surface');
    els.budgetInput     = document.getElementById('jgq-ai-budget');
    // Step 5
    els.summaryContent  = document.getElementById('jgq-ai-summary-content');
  }

  function bindEvents() {
    if (els.heroStart) els.heroStart.addEventListener('click', startWizard);
    if (els.btnPrev)   els.btnPrev.addEventListener('click', previousStep);
    if (els.btnNext)   els.btnNext.addEventListener('click', nextStep);
    if (els.form)      els.form.addEventListener('submit', handleSubmit);

    // Step 1 – event type (single)
    document.querySelectorAll('[data-jgq-ai-step="1"] .jgq-ai-cards-grid:not(.jgq-ai-cards-grid--compact) .jgq-ai-card').forEach(function(c) {
      c.addEventListener('click', function() { selectCard(this, 'type-evenement', 'selectedEvent'); });
    });
    // Step 1 – age (single)
    document.querySelectorAll('.jgq-ai-cards-grid--compact .jgq-ai-card').forEach(function(c) {
      c.addEventListener('click', function() { selectCard(this, 'tranche-age', 'selectedAge'); });
    });
    // Step 2 – variant cards (multi)
    document.querySelectorAll('.jgq-ai-card--variant').forEach(function(c) {
      c.addEventListener('click', function() { toggleVariantCard(this); });
    });
    // Dates
    if (els.dateInput) {
      els.dateInput.addEventListener('change', function() {
        if (els.dateFinVisible) {
          els.dateFinVisible.min = this.value;
          if (!els.dateFinVisible.value || els.dateFinVisible.value < this.value) {
            els.dateFinVisible.value = this.value;
            if (els.dateFinInput) els.dateFinInput.value = this.value;
          }
        }
      });
    }
    if (els.dateFinVisible) {
      els.dateFinVisible.addEventListener('change', function() {
        if (els.dateFinInput) els.dateFinInput.value = this.value;
      });
    }
    // Step 4 chips
    document.querySelectorAll('[data-step="4"] .jgq-ai-chip[data-value]').forEach(function(c) {
      c.addEventListener('click', function() { selectChip(this, 'services'); });
    });
    document.querySelectorAll('[aria-label="Surface"] .jgq-ai-chip[data-value]').forEach(function(c) {
      c.addEventListener('click', function() { selectChip(this, 'surface'); });
    });
    initBudgetSlider();
    if (els.catalogSearch) {
      els.catalogSearch.addEventListener('input', debounce(function(e) { filterCatalog(e.target.value); }, 300));
    }
    var viewAllBtn = document.getElementById('jgq-ai-view-all');
    if (viewAllBtn) {
      viewAllBtn.addEventListener('click', function() {
        if (els.catalogSearch) els.catalogSearch.value = '';
        renderCatalogGrid(state.catalog.filter(function(p) { return !isConsumable(p) && !isSaleItem(p); }));
      });
    }
    // Sync participants early (step 1) ↔ step 4
    function syncParticipants(from, to) {
      if (!from || !to) return;
      from.addEventListener('input', function() {
        to.value = from.value;
        if (state.currentStep === 3) renderForfaits();
      });
    }
    syncParticipants(els.participantsEarly, els.participants);
    syncParticipants(els.participants, els.participantsEarly);
  }

  function initDateMin() {
    if (!els.dateInput) return;
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + CONFIG.DATE_MIN_DAYS);
    els.dateInput.min = tomorrow.toISOString().split('T')[0];
  }

  function startWizard() {
    if (els.hero) els.hero.style.display = 'none';
    if (els.wizard) {
      els.wizard.hidden = false;
      els.wizard.classList.remove('jgq-ai-wizard--hidden');
    }
    if (els.sticky) els.sticky.hidden = false;
    state.currentStep = 1;
    renderStep(1);
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch(e) {}
  }

  function selectCard(card, inputId, stateKey) {
    var container = card.closest('.jgq-ai-cards-grid');
    var input = document.getElementById('jgq-ai-' + inputId);
    container.querySelectorAll('.jgq-ai-card').forEach(function(c) {
      c.classList.remove('jgq-ai-card--selected');
    });
    card.classList.add('jgq-ai-card--selected');
    if (input) input.value = card.dataset.value;
    state[stateKey] = card.dataset.value;
    updateAssistantMessage();
  }

  function toggleVariantCard(card) {
    var val = card.dataset.value;
    if (card.classList.contains('jgq-ai-card--selected')) {
      card.classList.remove('jgq-ai-card--selected');
      state.selectedVariants = state.selectedVariants.filter(function(v) { return v !== val; });
    } else {
      card.classList.add('jgq-ai-card--selected');
      if (state.selectedVariants.indexOf(val) === -1) state.selectedVariants.push(val);
    }
    if (els.typesJeuxInput) els.typesJeuxInput.value = state.selectedVariants.join(',');
  }

  function selectChip(chip, inputId) {
    var container = chip.closest('.jgq-ai-chips');
    var input = document.getElementById('jgq-ai-' + inputId);
    container.querySelectorAll('.jgq-ai-chip').forEach(function(c) {
      c.classList.remove('jgq-ai-chip--selected');
    });
    chip.classList.add('jgq-ai-chip--selected');
    if (input) input.value = chip.dataset.value;
  }

  function initBudgetSlider() {
    var range = document.getElementById('jgq-budget-range');
    var display = document.getElementById('jgq-budget-display');
    var input = document.getElementById('jgq-ai-budget');
    if (!range) return;
    var VALUES = [250, 500, 750, 1000, 1500, 2000, 3000, 4000];
    function fmt(idx) {
      var v = VALUES[idx];
      return v >= 4000 ? '4 000 $+' : v.toLocaleString('fr-CA') + ' $';
    }
    function update() {
      var idx = parseInt(range.value, 10);
      range.style.setProperty('--range-pct', (idx / (VALUES.length - 1) * 100) + '%');
      if (display) display.textContent = fmt(idx);
      if (input)   input.value = fmt(idx);
    }
    range.addEventListener('input', update);
    update();
  }

  function renderStep(n) {
    state.currentStep = n;
    document.querySelectorAll('.jgq-ai-step').forEach(function(step) {
      var sn = parseInt(step.dataset.jgqAiStep, 10);
      var active = sn === n;
      step.toggleAttribute('hidden', !active);
      step.classList.toggle('jgq-ai-step--active', active);
    });
    if (els.btnPrev) {
      els.btnPrev.disabled = n <= 1;
      els.btnPrev.style.visibility = n <= 1 ? 'hidden' : 'visible';
    }
    if (els.btnNext) {
      var isLast = n === CONFIG.STEP_TOTAL;
      els.btnNext.innerHTML = isLast
        ? 'Envoyer <svg class="jgq-ai-btn__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>'
        : 'Continuer <svg class="jgq-ai-btn__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
    }
    if (n === 3) loadRecommendations();
    if (n === 5) renderSummary();
    updateProgress();
    updateAssistantMessage();
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch(e) {}
  }

  function updateProgress() {
    var pct = Math.round((state.currentStep / CONFIG.STEP_TOTAL) * 100);
    if (els.progressBar) els.progressBar.style.width = pct + '%';
    if (els.stepIndicator) els.stepIndicator.textContent = 'Étape ' + state.currentStep;
  }

  function updateAssistantMessage() {
    if (!els.assistantText) return;
    var msgs = {
      1: "Choisissez votre type d'événement et la tranche d'âge. Je vous recommanderai les jeux parfaits !",
      2: "Sélectionnez le(s) type(s) de jeux, vous pouvez en choisir plusieurs !",
      3: state.selectedForfait
        ? 'Forfait sélectionné ! Ajoutez maintenant votre jeu gonflable ci-dessous.'
        : (state.selectedProducts.length > 0
          ? 'Excellent choix ! Vous avez sélectionné ' + state.selectedProducts.length + ' jeu(x).'
          : 'Voici les jeux disponibles pour vos dates. Un forfait optionnel est aussi proposé en haut !'),
      4: 'Personnalisez votre location avec les options qui vous conviennent.',
      5: "Vérifiez vos informations et envoyez votre demande. Notre équipe vous répond sous 24h !"
    };
    els.assistantText.textContent = msgs[state.currentStep] || '';
  }

  function validateStep(n) {
    if (n === 1) {
      if (!els.typeInput || !els.typeInput.value) return false;
      if (!els.ageInput  || !els.ageInput.value)  return false;
      if (!els.dateInput || !els.dateInput.value) return false;
      if (!els.dateFinVisible || !els.dateFinVisible.value) return false;
      if (!els.adresseInput || els.adresseInput.value.length < 5) return false;
      if (!els.codePostalInput || els.codePostalInput.value.trim().length < 6) return false;
      if (!els.heureDebut || !els.heureDebut.value) return false;
      if (!els.heureFin  || !els.heureFin.value)   return false;
    }
    if (n === 5) {
      var prenom = document.getElementById('jgq-ai-prenom');
      var nom    = document.getElementById('jgq-ai-nom');
      var email  = document.getElementById('jgq-ai-email');
      var tel    = document.getElementById('jgq-ai-telephone');
      if (!prenom || !prenom.value) return false;
      if (!nom    || !nom.value)    return false;
      if (!email  || !email.value || !email.checkValidity()) return false;
      if (!tel    || !tel.value)    return false;
    }
    return true;
  }

  function showError(msg) {
    if (!els.error) return;
    els.error.textContent = msg;
    els.error.classList.add('jgq-quote-form-error--visible');
  }

  function hideError() {
    if (!els.error) return;
    els.error.classList.remove('jgq-quote-form-error--visible');
  }

  function nextStep() {
    hideError();
    if (!validateStep(state.currentStep)) {
      showError('Veuillez remplir tous les champs obligatoires.');
      return;
    }
    if (state.currentStep < CONFIG.STEP_TOTAL) {
      renderStep(state.currentStep + 1);
    }
  }

  function previousStep() {
    hideError();
    if (state.currentStep > 1) {
      renderStep(state.currentStep - 1);
    }
  }

  // ── Category helpers ─────────────────────────────────────────────
  function kwMatch(p, kwList) {
    var title = ' ' + (p.title || '').toLowerCase() + ' ';
    var tags  = (p.tags || []).map(function(t) { return t.toLowerCase(); });
    return kwList.some(function(kw) {
      return title.indexOf(kw) !== -1 ||
             tags.some(function(t) { return t.indexOf(kw) !== -1; });
    });
  }
  function isConsumable(p) { return kwMatch(p, CONSUMABLE_KW); }
  function isMachine(p)    { return !!p.in_machine || kwMatch(p, MACHINE_KW); }
  function isAccessory(p)  { return kwMatch(p, ACCESSORY_KW); }
  function isSaleItem(p)   { return kwMatch(p, SALE_KW); }
  function isInflatable(p) {
    if (p.in_machine) return false;
    if (p.in_eau) return true;
    return !isConsumable(p) && !kwMatch(p, MACHINE_KW) && !isAccessory(p) && !isSaleItem(p);
  }
  function matchesVariant(p, v) {
    if (v === 'aquatique') return !!p.in_eau || kwMatch(p, VARIANT_KW.aquatique || []);
    return kwMatch(p, VARIANT_KW[v] || []);
  }

  // ── Catalog ───────────────────────────────────────────────────────
  function loadCatalog() {
    var root = window.location.origin;
    fetch(root + '/collections/all/products.json?limit=250', { credentials: 'omit' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data && data.products ? data.products : [];
        state.catalog = products.map(function(p) {
          var v0 = p.variants && p.variants.length ? p.variants[0] : null;
          var price = null;
          if (v0 && v0.price) price = parseFloat(String(v0.price).replace(',', '.'));
          var img = '';
          if (p.images && p.images.length) img = p.images[0].src;
          else if (p.image && p.image.src) img = p.image.src;
          return normalizeProduct({
            id: p.id, crm_id: null, title: p.title,
            price: price, product_type: p.product_type,
            image: img, available: p.available !== false,
            tags: p.tags || [], handle: p.handle,
            in_eau: false, in_machine: false
          });
        });
        console.log('[JGQ] Catalog from API:', state.catalog.length);
        return Promise.all([
          fetch(root + '/collections/jeux-d-eau/products.json?limit=250', { credentials: 'omit' })
            .then(function(r) { return r.ok ? r.json() : { products: [] }; })
            .catch(function() { return { products: [] }; }),
          fetch(root + '/collections/machine-accessoires/products.json?limit=250', { credentials: 'omit' })
            .then(function(r) { return r.ok ? r.json() : { products: [] }; })
            .catch(function() { return { products: [] }; }),
          fetch(root + '/collections/bambins-0-5-ans/products.json?limit=250', { credentials: 'omit' })
            .then(function(r) { return r.ok ? r.json() : { products: [] }; })
            .catch(function() { return { products: [] }; }),
          fetch(root + '/collections/2-a-8-ans/products.json?limit=250', { credentials: 'omit' })
            .then(function(r) { return r.ok ? r.json() : { products: [] }; })
            .catch(function() { return { products: [] }; }),
          fetch(root + '/collections/jusqua-12-ans/products.json?limit=250', { credentials: 'omit' })
            .then(function(r) { return r.ok ? r.json() : { products: [] }; })
            .catch(function() { return { products: [] }; }),
          fetch(root + '/collections/tous-ages/products.json?limit=250', { credentials: 'omit' })
            .then(function(r) { return r.ok ? r.json() : { products: [] }; })
            .catch(function() { return { products: [] }; })
        ]);
      })
      .then(function(results) {
        var eauIds     = new Set((results[0].products || []).map(function(p) { return p.id; }));
        var machIds    = new Set((results[1].products || []).map(function(p) { return p.id; }));
        var bamIds     = new Set((results[2].products || []).map(function(p) { return p.id; }));
        var a8Ids      = new Set((results[3].products || []).map(function(p) { return p.id; }));
        var a12Ids     = new Set((results[4].products || []).map(function(p) { return p.id; }));
        var tousIds    = new Set((results[5].products || []).map(function(p) { return p.id; }));
        console.log('[JGQ] jeux-d-eau:', eauIds.size, '| machine-accessoires:', machIds.size, '| bambins:', bamIds.size, '| 2-8ans:', a8Ids.size, '| 12ans:', a12Ids.size, '| tous-ages:', tousIds.size);
        state.catalog.forEach(function(p) {
          if (eauIds.has(p.id))  p.in_eau = true;
          if (machIds.has(p.id) && !eauIds.has(p.id)) {
            p.in_machine = true;
            p.category = isConsumable(p) ? 'Consommable' : 'Machine';
          }
          if (bamIds.has(p.id))  p.age_bambins = true;
          if (a8Ids.has(p.id))   p.age_2a8 = true;
          if (a12Ids.has(p.id))  p.age_12 = true;
          if (tousIds.has(p.id)) p.age_tous = true;
        });
        var nEau = state.catalog.filter(function(p) { return p.in_eau; }).length;
        var nMac = state.catalog.filter(function(p) { return p.in_machine; }).length;
        console.log('[JGQ] Flags applied | in_eau:', nEau, '| in_machine:', nMac);
        // Apply CRM IDs from static map
        var crmMapEl = document.getElementById('jgq-crm-map');
        if (crmMapEl) {
          try {
            var crmMap = JSON.parse(crmMapEl.textContent);
            var titleToId = {};
            crmMap.forEach(function(e) { titleToId[e.title.toLowerCase()] = e.crm_id; });
            var matched = 0;
            state.catalog.forEach(function(p) {
              var id = titleToId[p.title.toLowerCase()];
              if (id) { p.crm_id = id; matched++; }
            });
            console.log('[JGQ] CRM IDs matched:', matched, '/', state.catalog.length);
          } catch(e) { console.warn('[JGQ] CRM map parse error:', e); }
        }
      })
      .catch(function(err) {
        console.error('[JGQ] Catalog load error:', err);
        var jsonEl = document.getElementById('jgq-shopify-products-json');
        if (jsonEl) {
          try {
            var raw = JSON.parse(jsonEl.textContent);
            state.catalog = (Array.isArray(raw) ? raw : (raw.products || [])).map(normalizeProduct);
          } catch(e) {}
        }
      });
  }

  function normalizeProduct(p) {
    var tagsArr = Array.isArray(p.tags) ? p.tags
                  : (typeof p.tags === 'string' ? p.tags.split(',').map(function(t){ return t.trim(); }) : []);
    var price = p.price != null ? parseFloat(p.price) : null;
    if (isNaN(price)) price = null;
    var cat = p.product_type || p.category || '';
    var o = {
      id: p.id,
      shopify_id: p.shopify_id || p.id,
      crm_id: p.crm_id || null,
      title: p.title || 'Produit',
      price: price,
      category: cat,
      image: p.image || '',
      available: p.available !== false,
      tags: tagsArr,
      handle: p.handle || '',
      url: '/products/' + (p.handle || ''),
      in_machine: p.in_machine === true || p.in_machine === 'true',
      in_eau: p.in_eau === true || p.in_eau === 'true'
    };
    if ((o.title || '').toLowerCase().indexOf('nettoyage') !== -1) {
      o.category = 'Service';
    } else if (o.in_machine) {
      o.category = isConsumable(o) ? 'Consommable' : 'Machine';
    } else if (isConsumable(o)) {
      o.category = 'Consommable';
    } else if (kwMatch(o, MACHINE_KW)) {
      o.category = 'Machine';
    } else if (isAccessory(o)) {
      o.category = 'Accessoire';
    } else {
      o.category = 'Jeu gonflable';
    }
    return o;
  }

  // ── Availability via CRM ─────────────────────────────────────────
  function fetchAvailability(dateDebut, dateFin, callback) {
    var d1 = new Date(dateDebut);
    var d2 = new Date(dateFin);
    var dur = Math.max(1, Math.round((d2 - d1) / 86400000) + 1);
    var url = CONFIG.CRM_API + '?start_date=' + encodeURIComponent(dateDebut)
            + '&end_date=' + encodeURIComponent(dateFin)
            + '&duration=' + dur;
    var slowTimer = setTimeout(function() {
      if (els.recLoadingSub) els.recLoadingSub.style.display = 'block';
    }, 2000);
    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        clearTimeout(slowTimer);
        console.log('[JGQ] CRM raw response:', JSON.stringify(data).substring(0, 300));
        if (data && data.success) {
          var ids = (data.products || []).map(function(p) { return parseInt(p.id, 10); }).filter(Boolean);
          console.log('[JGQ] CRM available IDs:', ids.slice(0, 10), '| total:', ids.length);
          var sampleCrmIds = state.catalog.slice(0, 5).map(function(p) { return p.crm_id; });
          console.log('[JGQ] Catalog sample crm_ids:', sampleCrmIds);
          if (ids.length > 0) {
            state.availableCrmIds = new Set(ids);
            state.catalogCrmIds   = new Set((data.catalog_ids || []).map(function(id){ return parseInt(id,10); }).filter(Boolean));
            state.availabilityLoaded = true;
          } else {
            console.warn('[JGQ] CRM returned 0 available products - showing full catalog');
            state.availabilityLoaded = false;
          }
        } else {
          console.warn('[JGQ] CRM API did not return success - showing full catalog. Keys:', data ? Object.keys(data) : 'null');
          state.availabilityLoaded = false;
        }
        callback(null);
      })
      .catch(function(err) {
        clearTimeout(slowTimer);
        console.warn('[JGQ] Availability API error (CORS?):', err);
        state.availabilityLoaded = false;
        callback(null);
      });
  }

  function isProductAvailable(p) {
    if (!state.availabilityLoaded) return true;
    if (!p.crm_id) return true;
    var crmId = parseInt(p.crm_id, 10);
    if (isNaN(crmId) || crmId <= 0) return true;
    return state.availableCrmIds.has(crmId);
  }

  // ── Load recommendations ──────────────────────────────────────────
  function loadRecommendations() {
    if (!els.recLoading || !els.recContainer) return;
    els.recLoading.hidden = false;
    els.recContainer.hidden = true;
    if (els.dispoBanner) els.dispoBanner.hidden = true;
    if (els.recLoadingSub) els.recLoadingSub.style.display = 'none';

    var dateDebut = els.dateInput ? els.dateInput.value : '';
    var dateFin   = els.dateFinVisible ? els.dateFinVisible.value : dateDebut;

    function doRender() {
      els.recLoading.hidden = true;
      els.recContainer.hidden = false;
      if (dateDebut) showDispoBanner(dateDebut, dateFin || dateDebut);
      renderRecommendations();
      var pool = state.catalog.filter(function(p) { return isInflatable(p); });
      if (!pool.length) pool = state.catalog.filter(function(p) { return !isConsumable(p); });
      if (!pool.length) pool = state.catalog;
      renderCatalogGrid(pool);
    }

    if (dateDebut) {
      fetchAvailability(dateDebut, dateFin || dateDebut, function() { doRender(); });
    } else {
      setTimeout(doRender, 400);
    }
  }

  function showDispoBanner(d1, d2) {
    if (!els.dispoBanner) return;
    var allInflatables = state.catalog.filter(function(p) { return isInflatable(p); });
    var withCrmId = allInflatables.filter(function(p) { return p.crm_id && parseInt(p.crm_id, 10) > 0; });
    var canShowRealCount = state.availabilityLoaded && withCrmId.length >= 5;
    var fmt = function(s) {
      if (!s) return '';
      var parts = s.split('-');
      return parts[2] + '/' + parts[1] + '/' + parts[0];
    };
    var text;
    if (canShowRealCount) {
      var available = allInflatables.filter(function(p) { return isProductAvailable(p); }).length;
      text = '✅ ' + available + ' jeu' + (available > 1 ? 'x' : '') + ' disponible' + (available > 1 ? 's' : '')
           + ' du ' + fmt(d1) + ' au ' + fmt(d2);
      els.dispoBanner.classList.remove('jgq-ai-dispo-banner--warn');
    } else {
      text = '📋 Catalogue complet affiché, disponibilités confirmées à la réservation';
      els.dispoBanner.classList.add('jgq-ai-dispo-banner--warn');
    }
    els.dispoBanner.textContent = text;
    els.dispoBanner.hidden = false;
  }

  // ── Forfaits (bundles optionnels) ─────────────────────────────────
  var FORFAITS = [
    {
      id: 'fete-enfants',
      name: "Forfait Fête d'enfants (20 portions)",
      icon: '🎂',
      portionsLabel: 'Idéal pour ~1–30 personnes · 20 portions',
      includes: [
        'Jeu gonflable (au choix)',
        'Machine à barbe à papa',
        '2 sacs de sucre',
        '25 cônes'
      ],
      items: [
        { match: ['machine à barbe à papa', 'machine a barbe a papa'], qty: 1, preferExact: true },
        { match: ['sucre à barbe à papa (sachet)', 'sucre a barbe a papa (sachet)', 'sucre à barbe', 'sucre a barbe'], qty: 2, exclude: ['pinte'] },
        { match: ['cônes à barbe', 'cones a barbe'], qty: 25 }
      ]
    },
    {
      id: 'fete-famille',
      name: 'Forfait Fête de famille (70 portions)',
      icon: '👨‍👩‍👧‍👦',
      portionsLabel: 'Idéal pour ~40–100 personnes · 70 portions',
      includes: [
        'Jeu gonflable (au choix)',
        'Machine à barbe à papa',
        '1 pinte de sucre',
        '75 cônes'
      ],
      items: [
        { match: ['machine à barbe à papa', 'machine a barbe a papa'], qty: 1, preferExact: true },
        { match: ['sucre à barbe à papa (pinte)', 'sucre a barbe a papa (pinte)', 'pinte'], qty: 1 },
        { match: ['cônes à barbe', 'cones a barbe'], qty: 75 }
      ]
    },
    {
      id: 'party-piscine',
      name: 'Forfait Party Piscine',
      icon: '🏊',
      portionsLabel: 'Idéal pour fêtes aquatiques',
      aquatique: true,
      includes: [
        'Jeu gonflable d\'eau (au choix)',
        'Canon à mousse',
        '2 sachets de mousse'
      ],
      items: [
        { match: ['canon à mousse', 'canon a mousse'], qty: 1, preferExact: true },
        { match: ['solution moussante', 'solution mousse', 'liquide moussant'], qty: 2 }
      ]
    },
    {
      id: 'pop-corpo',
      name: 'Forfait Pop Corpo (50 portions)',
      icon: '🍿',
      portionsLabel: 'Idéal pour ~30–70 personnes · 50 portions',
      includes: [
        'Jeu gonflable (au choix)',
        'Machine à popcorn',
        '5 sachets popcorn',
        '50 sacs de service',
        'Nettoyage'
      ],
      items: [
        { match: ['machine à popcorn - 8 oz', 'machine a popcorn - 8 oz', 'machine à popcorn', 'machine a popcorn'], qty: 1, preferExact: true, exclude: ['nettoyage'] },
        { match: ['popcorn, sachet', 'popcorn sachet'], qty: 5 },
        { match: ['sac de service'], qty: 50 },
        { match: ['nettoyage - machine à popcorn 8', 'nettoyage - machine a popcorn 8', 'nettoyage - machine à popcorn', 'nettoyage - machine a popcorn'], qty: 1 }
      ]
    }
  ];

  function getParticipantsCount() {
    var raw = (els.participantsEarly && els.participantsEarly.value)
      || (els.participants && els.participants.value)
      || '';
    var n = parseInt(raw, 10);
    return (n > 0) ? n : 0;
  }

  function getRecommendedForfaitId() {
    var isAqua = state.selectedVariants.indexOf('aquatique') !== -1;
    if (isAqua) return 'party-piscine';

    var n = getParticipantsCount();
    var event = state.selectedEvent || '';
    var age = state.selectedAge || '';

    if (n > 0) {
      if (n <= 30) return 'fete-enfants';
      if (n >= 56) return 'fete-famille';
      // 31–55
      if (event === 'Corporatif' || age === 'Adultes') return 'pop-corpo';
      if (event === 'Mariage') return 'fete-famille';
      return 'fete-enfants';
    }

    if (event === 'Corporatif' || age === 'Adultes') return 'pop-corpo';
    if (event === 'Mariage') return 'fete-famille';
    if (event === 'Anniversaire' || age === '0-5 ans' || age === '6-12 ans') return 'fete-enfants';
    return 'fete-enfants';
  }

  function findCatalogProduct(matchList, excludeList) {
    excludeList = excludeList || [];
    var best = null;
    var bestScore = -1;
    state.catalog.forEach(function(p) {
      var t = (p.title || '').toLowerCase();
      if (excludeList.some(function(ex) { return t.indexOf(ex) !== -1; })) return;
      for (var i = 0; i < matchList.length; i++) {
        if (t.indexOf(matchList[i]) !== -1) {
          // Lower index in matchList = better; shorter title = slight bonus
          var score = (matchList.length - i) * 1000 - t.length;
          if (score > bestScore) {
            bestScore = score;
            best = p;
          }
          break;
        }
      }
    });
    return best;
  }

  function resolveForfaitItems(forfait) {
    return (forfait.items || []).map(function(spec) {
      var prod = findCatalogProduct(spec.match, spec.exclude || []);
      if (!prod) return null;
      return {
        id: prod.id,
        title: prod.title,
        price: prod.price,
        crm_id: prod.crm_id,
        qty: spec.qty || 1,
        fromForfait: forfait.id
      };
    }).filter(Boolean);
  }

  function estimateForfaitPrice(forfait) {
    var items = resolveForfaitItems(forfait);
    if (!items.length) return null;
    var sum = 0;
    var hasPrice = false;
    items.forEach(function(it) {
      if (it.price != null && !isNaN(it.price)) {
        sum += it.price * (it.qty || 1);
        hasPrice = true;
      }
    });
    return hasPrice ? sum : null;
  }

  function clearForfaitProducts(forfaitId) {
    state.selectedProducts = state.selectedProducts.filter(function(p) {
      return p.fromForfait !== forfaitId;
    });
  }

  function updateForfaitPayload() {
    if (els.forfaitInput) {
      els.forfaitInput.value = state.selectedForfait
        ? (FORFAITS.filter(function(f) { return f.id === state.selectedForfait; })[0] || {}).name || state.selectedForfait
        : '';
    }
  }

  function toggleForfait(forfaitId) {
    if (state.selectedForfait === forfaitId) {
      clearForfaitProducts(forfaitId);
      state.selectedForfait = null;
    } else {
      if (state.selectedForfait) clearForfaitProducts(state.selectedForfait);
      var forfait = FORFAITS.filter(function(f) { return f.id === forfaitId; })[0];
      if (!forfait) return;
      var items = resolveForfaitItems(forfait);
      items.forEach(function(it) {
        var existing = null;
        state.selectedProducts.forEach(function(p) { if (p.id === it.id) existing = p; });
        if (existing) {
          // Ne pas « voler » une sélection manuelle : on augmente juste la qty si besoin
          if (existing.fromForfait) {
            existing.qty = it.qty;
            existing.fromForfait = forfaitId;
          } else {
            existing.qty = Math.max(existing.qty || 1, it.qty);
          }
        } else {
          state.selectedProducts.push(it);
        }
      });
      state.selectedForfait = forfaitId;
    }
    updateForfaitPayload();
    updateProductsPayload();
    updateSelectedTags();
    updateAssistantMessage();
    if (state.currentStep === 3) {
      renderRecommendations();
      filterCatalog(els.catalogSearch ? els.catalogSearch.value : '');
    }
  }

  function renderForfaits() {
    if (!els.recForfaits) return;
    var recommendedId = getRecommendedForfaitId();
    els.recForfaits.innerHTML = FORFAITS.map(function(f) {
      var isSelected = state.selectedForfait === f.id;
      var isRecommended = recommendedId === f.id;
      var price = estimateForfaitPrice(f);
      var priceLabel = price != null
        ? formatMoney(price) + ' + jeu au choix'
        : 'Forfait : prix selon jeu choisi';
      var badges = '<span class="jgq-ai-forfait-badge jgq-ai-forfait-badge--optional">Optionnel</span>';
      if (isRecommended && f.aquatique) {
        badges += '<span class="jgq-ai-forfait-badge jgq-ai-forfait-badge--aquatique">Recommandé · Aquatique</span>';
      } else if (isRecommended) {
        badges += '<span class="jgq-ai-forfait-badge jgq-ai-forfait-badge--recommended">Recommandé pour vous</span>';
      }
      var includes = f.includes.map(function(line) {
        return '<li>' + line + '</li>';
      }).join('');
      var cls = 'jgq-ai-forfait-card'
        + (isSelected ? ' jgq-ai-forfait-card--selected' : '')
        + (isRecommended ? ' jgq-ai-forfait-card--recommended' : '');
      return '<button type="button" class="' + cls + '" data-forfait-id="' + f.id + '" onclick="JGQ.toggleForfait(\'' + f.id + '\')">'
        + '<div class="jgq-ai-forfait-card__check">✓</div>'
        + '<div class="jgq-ai-forfait-card__top">'
        +   '<span class="jgq-ai-forfait-card__icon" aria-hidden="true">' + f.icon + '</span>'
        +   '<div>'
        +     '<h4 class="jgq-ai-forfait-card__title">' + f.name + '</h4>'
        +     '<p class="jgq-ai-forfait-card__portions">' + f.portionsLabel + '</p>'
        +   '</div>'
        + '</div>'
        + '<div class="jgq-ai-forfait-card__badges">' + badges + '</div>'
        + '<ul class="jgq-ai-forfait-card__includes">' + includes + '</ul>'
        + '<div class="jgq-ai-forfait-card__price">' + priceLabel + '</div>'
        + '</button>';
    }).join('');
    if (els.recSecForfaits) els.recSecForfaits.style.display = '';
  }

  // ── Render recommendations ────────────────────────────────────────
  function renderRecommendations() {
    renderForfaits();

    var pool = state.catalog.filter(function(p) {
      return isInflatable(p) && isProductAvailable(p);
    });

    var ageRange = state.selectedAge || 'Mixte';
    var byAge = pool.filter(function(p) {
      if (ageRange === 'Mixte') return true;
      var inAnyAgeCol = p.age_bambins || p.age_2a8 || p.age_12 || p.age_tous;
      if (!inAnyAgeCol) return true; // not in any age collection → show everywhere
      if (ageRange === '0-5 ans')  return !!(p.age_bambins || p.age_tous);
      if (ageRange === '6-12 ans') return !!(p.age_2a8 || p.age_12 || p.age_tous);
      if (ageRange === 'Adultes')  return !!(p.age_12 || p.age_tous);
      return true;
    });
    if (!byAge.length) byAge = pool;

    var variants = state.selectedVariants || [];
    var byVariant = byAge;
    if (variants.length > 0) {
      var matched = byAge.filter(function(p) {
        return variants.some(function(v) {
          if (v === 'aquatique') return p.in_eau || matchesVariant(p, v);
          return matchesVariant(p, v);
        });
      });
      console.log('[JGQ] Variant filter:', variants, '| matched:', matched.length, '/', byAge.length);
      byVariant = matched.length > 0 ? matched : byAge;
    }

    var sorted = byVariant.slice().sort(function(a, b) { return (b.price || 0) - (a.price || 0); });

    var N = CONFIG.MAX_PER_TIER;
    var premium = [], best = [], economic = [];

    if (sorted.length > 0) {
      // Deduplicate the sorted array itself first (safety)
      var deduped = [];
      var seenIds = {};
      sorted.forEach(function(p) { if (!seenIds[p.id]) { seenIds[p.id] = true; deduped.push(p); } });
      sorted = deduped;

      if (sorted.length <= N) {
        // Too few - same products in all tiers (no choice)
        premium  = sorted.slice();
        best     = sorted.slice();
        economic = sorted.slice();
      } else {
        // Assign each product to exactly ONE tier by position (no overlap)
        // premium = top N by price, economic = bottom N, best = middle
        premium  = sorted.slice(0, N);
        economic = sorted.slice(-N);
        // best = everything in between, pick N from the middle
        var middleStart = N;
        var middleEnd   = sorted.length - N;
        var middle      = sorted.slice(middleStart, middleEnd);
        if (middle.length === 0) {
          // Overlap needed - not enough products for 3 distinct tiers
          var mid = Math.floor(sorted.length / 2);
          best = sorted.slice(Math.max(0, mid - 1), mid - 1 + N);
          if (best.length < N) best = sorted.slice(0, N);
        } else {
          // Pick N from the middle (centered)
          var mMid = Math.floor(middle.length / 2);
          var mStart = Math.max(0, mMid - Math.floor(N / 2));
          best = middle.slice(mStart, mStart + N);
          if (best.length < N) best = middle.slice(0, N);
          if (best.length < N) best = sorted.slice(Math.floor(sorted.length / 3), Math.floor(sorted.length / 3) + N);
        }
      }
    }

    if (els.recPremium)  els.recPremium.innerHTML  = premium.map(renderRecCard).join('') || '<p style="color:var(--jgq-muted);font-size:13px;padding:8px;">Aucun jeu dans cette gamme pour vos dates.</p>';
    if (els.recBest)     els.recBest.innerHTML     = best.map(renderRecCard).join('')    || '<p style="color:var(--jgq-muted);font-size:13px;padding:8px;">Aucun jeu dans cette gamme pour vos dates.</p>';
    if (els.recEconomic) els.recEconomic.innerHTML = economic.map(renderRecCard).join('')|| '<p style="color:var(--jgq-muted);font-size:13px;padding:8px;">Aucun jeu dans cette gamme pour vos dates.</p>';

    if (els.recSecPremium)  els.recSecPremium.style.display  = premium.length  ? '' : 'none';
    if (els.recSecBest)     els.recSecBest.style.display     = best.length     ? '' : 'none';
    if (els.recSecEconomic) els.recSecEconomic.style.display = economic.length ? '' : 'none';

    // Machines - all in machine-accessoires, regardless of CRM availability
    var allInMachine = state.catalog.filter(function(p) { return p.in_machine; });
    console.log('[JGQ] All in_machine titles:', allInMachine.map(function(p){return p.title;}));
    allInMachine.forEach(function(p) {
      console.log('[JGQ] Check:', p.title, '| consumable:', isConsumable(p), '| saleItem:', isSaleItem(p));
    });
    var machines = allInMachine.filter(function(p) {
      if (isConsumable(p)) return false;
      if (isSaleItem(p)) return false;
      return true;
    });
    console.log('[JGQ] Machines filtered:', machines.length, machines.map(function(p){return p.title;}));
    if (els.recMachines) {
      if (machines.length) {
        els.recMachines.innerHTML = machines.map(renderRecCard).join('');
        if (els.recSecMachines) els.recSecMachines.style.display = '';
      } else {
        if (els.recSecMachines) els.recSecMachines.style.display = 'none';
      }
    }
  }

  function renderRecCard(product) {
    var isSelected = state.selectedProducts.some(function(p) { return p.id === product.id; });
    var avail = isProductAvailable(product);
    var badge;
    if (!state.availabilityLoaded) {
      badge = '<span class="jgq-ai-badge jgq-ai-badge--unconfirmed">Dispo non confirmée</span>';
    } else if (avail) {
      badge = '<span class="jgq-ai-badge jgq-ai-badge--available">Disponible</span>';
    } else {
      badge = '<span class="jgq-ai-badge jgq-ai-badge--unavailable">Non disponible</span>';
    }
    var safe = product.title.replace(/'/g, "\\'").replace(/"/g, '&quot;');
    return '<div class="jgq-ai-rec-card' + (isSelected ? ' jgq-ai-rec-card--selected' : '') + '" data-id="' + product.id + '" onclick="JGQ.toggleProduct(' + product.id + ',\'' + safe + '\',' + (product.price || 0) + ')">'
      + '<div class="jgq-ai-rec-card__check">&#10003;</div>'
      + '<div class="jgq-ai-rec-card__image">'
      + (product.image
          ? '<img src="' + product.image + '" alt="' + product.title + '" loading="lazy">'
          : '<div style="display:grid;place-items:center;height:100%;font-size:40px;background:linear-gradient(135deg,var(--jgq-primary-soft),var(--jgq-lemon-soft))">&#127984;</div>')
      + '</div>'
      + '<div class="jgq-ai-rec-card__content">'
      + '<h4 class="jgq-ai-rec-card__title">' + product.title + '</h4>'
      + '<div class="jgq-ai-rec-card__meta">' + (product.category || 'Jeu gonflable') + '</div>'
      + '<div class="jgq-ai-rec-card__price">' + (product.price ? formatMoney(product.price) : 'Prix sur demande') + '</div>'
      + '<div class="jgq-ai-rec-card__availability">' + badge + '</div>'
      + '</div></div>';
  }

  function renderCatalogGrid(products) {
    if (!els.catalogGrid) return;
    var list = products !== undefined ? products : state.catalog.filter(function(p) { return !isConsumable(p) && !isSaleItem(p); });
    els.catalogGrid.innerHTML = list.map(renderRecCard).join('');
  }

  function filterCatalog(query) {
    if (!els.catalogGrid) return;
    var q = query.toLowerCase();
    var list = state.catalog.filter(function(p) {
      return !isConsumable(p) && !isSaleItem(p) &&
        (p.title.toLowerCase().indexOf(q) !== -1 || (p.category || '').toLowerCase().indexOf(q) !== -1);
    });
    els.catalogGrid.innerHTML = list.map(renderRecCard).join('');
  }

  // ── Machine → consommables mapping ───────────────────────────────
  var MACHINE_CONSOMMABLES_MAP = [
    {
      machineKw: ['barbe à papa', 'barbe a papa'],
      icon: '🍭',
      label: 'Machine à Barbe à Papa',
      consommablesKw: ['sucre à barbe', 'sucre a barbe', 'nettoyage - machine à barbe', 'nettoyage - machine a barbe', 'cônes à barbe', 'cones a barbe']
    },
    {
      machineKw: ['popcorn - 8 oz', 'popcorn 8 oz', 'popcorn 8oz'],
      icon: '🍿',
      label: 'Machine à Popcorn 8 oz',
      consommablesKw: ['popcorn, sachet', 'sac de service', 'nettoyage - machine à popcorn 8', 'nettoyage - machine a popcorn 8']
    },
    {
      machineKw: ['popcorn - 16 oz', 'popcorn 16 oz', 'popcorn 16oz'],
      icon: '🍿',
      label: 'Machine à Popcorn 16 oz',
      consommablesKw: ['popcorn, sachet', 'sac de service', 'nettoyage - machine à popcorn 16', 'nettoyage - machine a popcorn 16']
    },
    {
      machineKw: ['slush'],
      icon: '🥤',
      label: 'Machine à Slush',
      consommablesKw: ['base de slush', 'nettoyage - machine à slush', 'nettoyage - machine a slush']
    },
    {
      machineKw: ['canon à mousse', 'canon a mousse'],
      icon: '🫧',
      label: 'Canon à Mousse',
      consommablesKw: ['solution moussante', 'solution mousse']
    },
    {
      machineKw: ['machine à jus', 'machine a jus'],
      icon: '🥤',
      label: 'Machine à Jus',
      consommablesKw: ['nettoyage - machine à jus', 'nettoyage - machine a jus']
    }
  ];

  var modalState = { pendingProduct: null, consommablesQty: {} };

  function getMachineConfig(product) {
    var t = (product.title || '').toLowerCase();
    for (var i = 0; i < MACHINE_CONSOMMABLES_MAP.length; i++) {
      var cfg = MACHINE_CONSOMMABLES_MAP[i];
      if (cfg.machineKw.some(function(kw) { return t.indexOf(kw) !== -1; })) return cfg;
    }
    return null;
  }

  function getConsommablesForMachine(cfg) {
    return state.catalog.filter(function(p) {
      var t = (p.title || '').toLowerCase();
      return cfg.consommablesKw.some(function(kw) { return t.indexOf(kw) !== -1; });
    });
  }

  function openConsommablesModal(product, cfg) {
    var consommables = getConsommablesForMachine(cfg);
    if (!consommables.length) return false;
    modalState.pendingProduct = product;
    modalState.consommablesQty = {};
    var modal = document.getElementById('jgq-ai-consommables-modal');
    var icon  = document.getElementById('jgq-ai-modal-icon');
    var title = document.getElementById('jgq-ai-modal-title');
    var sub   = document.getElementById('jgq-ai-modal-subtitle');
    var items = document.getElementById('jgq-ai-modal-items');
    if (icon)  icon.textContent  = cfg.icon;
    if (title) title.textContent = 'Consommables pour : ' + product.title;
    if (sub)   sub.textContent   = 'Optionnel, ajoutez les quantités souhaitées';
    if (items) {
      items.innerHTML = consommables.map(function(c) {
        var img = c.image ? '<img class="jgq-ai-modal__item-img" src="' + c.image + '" alt="' + c.title + '" loading="lazy">'
                          : '<div class="jgq-ai-modal__item-img" style="display:grid;place-items:center;font-size:28px;">🛒</div>';
        return '<div class="jgq-ai-modal__item" id="modal-item-' + c.id + '" onclick="JGQ.modalToggleItem(' + c.id + ')">'
          + img
          + '<div class="jgq-ai-modal__item-info">'
          + '<div class="jgq-ai-modal__item-title">' + c.title + '</div>'
          + '<div class="jgq-ai-modal__item-price">' + (c.price ? formatMoney(c.price) : 'Prix sur demande') + '</div>'
          + '</div>'
          + '<div class="jgq-ai-modal__item-qty" onclick="event.stopPropagation()">'
          + '<button type="button" class="jgq-ai-modal__qty-btn" onclick="JGQ.modalChangeQty(' + c.id + ',-1)">-</button>'
          + '<span class="jgq-ai-modal__qty-val" id="modal-qty-' + c.id + '">0</span>'
          + '<button type="button" class="jgq-ai-modal__qty-btn" onclick="JGQ.modalChangeQty(' + c.id + ',1)">+</button>'
          + '</div>'
          + '</div>';
      }).join('');
    }
    if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    return true;
  }

  function modalToggleItem(id) {
    var qty = modalState.consommablesQty[id] || 0;
    if (qty === 0) { modalState.consommablesQty[id] = 1; }
    else { delete modalState.consommablesQty[id]; }
    var qtyEl = document.getElementById('modal-qty-' + id);
    var item  = document.getElementById('modal-item-' + id);
    if (qtyEl) qtyEl.textContent = modalState.consommablesQty[id] || 0;
    if (item)  item.classList.toggle('jgq-ai-modal__item--selected', !!modalState.consommablesQty[id]);
  }

  function modalChangeQty(id, delta) {
    var cur = modalState.consommablesQty[id] || 0;
    var next = Math.max(0, cur + delta);
    if (next === 0) delete modalState.consommablesQty[id];
    else modalState.consommablesQty[id] = next;
    var qtyEl = document.getElementById('modal-qty-' + id);
    var item  = document.getElementById('modal-item-' + id);
    if (qtyEl) qtyEl.textContent = next;
    if (item)  item.classList.toggle('jgq-ai-modal__item--selected', next > 0);
  }

  function closeConsommablesModal() {
    var modal = document.getElementById('jgq-ai-consommables-modal');
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
    modalState.pendingProduct = null;
    modalState.consommablesQty = {};
  }

  function confirmConsommables() {
    var modal = document.getElementById('jgq-ai-consommables-modal');
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
    Object.keys(modalState.consommablesQty).forEach(function(idStr) {
      var id  = parseInt(idStr, 10);
      var qty = modalState.consommablesQty[id];
      var prod = state.catalog.filter(function(p) { return p.id === id; })[0];
      if (!prod || !qty) return;
      var already = state.selectedProducts.filter(function(p) { return p.id === id; })[0];
      if (already) { already.qty = qty; }
      else { state.selectedProducts.push({ id: prod.id, title: prod.title, price: prod.price, crm_id: prod.crm_id, qty: qty }); }
    });
    updateProductsPayload();
    modalState.pendingProduct = null;
    modalState.consommablesQty = {};
    updateSelectedTags();
    updateAssistantMessage();
    if (state.currentStep === 3) {
      renderRecommendations();
      filterCatalog(els.catalogSearch ? els.catalogSearch.value : '');
    }
  }

  function updateProductsPayload() {
    var products = state.selectedProducts.map(function(p) {
      return { crm_item_id: parseInt(p.crm_id, 10), quantity: Math.max(1, parseInt(p.qty, 10) || 1), category: p.category || '' };
    }).filter(function(p) { return p.crm_item_id > 0; });
    if (els.produitsJson) els.produitsJson.value = JSON.stringify(products);
    if (els.produitsInput) els.produitsInput.value = products.map(function(p) { return p.crm_item_id; }).join(',');
  }

  function toggleProduct(id, title, price) {
    var idx = -1;
    state.selectedProducts.forEach(function(p, i) { if (p.id === id) idx = i; });
    if (idx >= 0) {
      var removed = state.selectedProducts[idx];
      state.selectedProducts.splice(idx, 1);
      // Si plus aucun item de ce forfait, désélectionner le forfait
      if (removed && removed.fromForfait) {
        var stillHas = state.selectedProducts.some(function(p) { return p.fromForfait === removed.fromForfait; });
        if (!stillHas && state.selectedForfait === removed.fromForfait) {
          state.selectedForfait = null;
          updateForfaitPayload();
        }
      }
    } else {
      var product = state.catalog.filter(function(p) { return p.id === id; })[0]
                  || { id: id, title: title, price: price, crm_id: null };
      var cfg = getMachineConfig(product);
      state.selectedProducts.push({ id: id, title: product.title, price: product.price, crm_id: product.crm_id, qty: 1 });
      if (cfg && openConsommablesModal(product, cfg)) {
        updateProductsPayload();
        updateSelectedTags();
        updateAssistantMessage();
        if (state.currentStep === 3) { renderRecommendations(); filterCatalog(els.catalogSearch ? els.catalogSearch.value : ''); }
        return;
      }
    }
    updateProductsPayload();
    updateSelectedTags();
    updateAssistantMessage();
    if (state.currentStep === 3) {
      renderRecommendations();
      filterCatalog(els.catalogSearch ? els.catalogSearch.value : '');
    }
  }

  function updateSelectedTags() {
    if (!els.selectedTags) return;
    if (!state.selectedProducts.length) {
      els.selectedTags.innerHTML = '<span style="color:var(--jgq-muted);font-size:13px;">Aucun jeu sélectionné</span>';
      if (els.selectedPanel) els.selectedPanel.style.display = 'none';
    } else {
      els.selectedTags.innerHTML = state.selectedProducts.map(function(p) {
        var safe = p.title.replace(/'/g, "\\'");
        var qtyLabel = (p.qty && p.qty > 1) ? ' ×' + p.qty : '';
        return '<span class="jgq-ai-selected-tag">' + p.title + qtyLabel
          + ' <span class="jgq-ai-selected-tag__remove" onclick="JGQ.toggleProduct(' + p.id + ',\'' + safe + '\',' + p.price + ')">&times;</span></span>';
      }).join('');
      if (els.selectedPanel) els.selectedPanel.style.display = 'flex';
    }
  }

  function renderSummary() {
    if (!els.summaryContent) return;
    var fmt = function(s) {
      if (!s) return '';
      var p = s.split('-');
      return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : s;
    };
    var forfaitName = '';
    if (state.selectedForfait) {
      var ff = FORFAITS.filter(function(f) { return f.id === state.selectedForfait; })[0];
      forfaitName = ff ? ff.name : state.selectedForfait;
    }
    var rows = [
      { label: 'Événement',          value: state.selectedEvent || 'Non spécifié' },
      { label: 'Âge des participants', value: state.selectedAge || 'Non spécifié' },
      { label: 'Types de jeux',       value: state.selectedVariants.length ? state.selectedVariants.join(', ') : 'Tous' },
      { label: 'Date de début',       value: els.dateInput ? fmt(els.dateInput.value) : '' },
      { label: 'Date de fin',         value: els.dateFinVisible ? fmt(els.dateFinVisible.value) : '' },
      { label: 'Adresse',             value: els.adresseInput ? els.adresseInput.value : '' },
      { label: 'Code postal',         value: els.codePostalInput ? els.codePostalInput.value : '' },
      { label: 'Surface',             value: els.surfaceInput ? (els.surfaceInput.value || 'Non spécifié') : 'Non spécifié' },
      { label: 'Forfait',             value: forfaitName || 'Aucun (optionnel)' },
      { label: 'Jeux sélectionnés',   value: state.selectedProducts.length ? state.selectedProducts.length + ' article(s)' : 'Aucun' }
    ];
    var html = rows.map(function(r) {
      return '<div class="jgq-ai-summary__row"><span class="jgq-ai-summary__label">' + r.label + '</span><span class="jgq-ai-summary__value">' + (r.value || '') + '</span></div>';
    }).join('');
    if (state.selectedProducts.length) {
      html += '<div class="jgq-ai-summary__row jgq-ai-summary__row--products"><span class="jgq-ai-summary__label">Détail des jeux</span><span class="jgq-ai-summary__value"><ul class="jgq-ai-summary__products-list">'
        + state.selectedProducts.map(function(p) {
            var qtyLabel = (p.qty && p.qty > 1) ? ' ×' + p.qty : '';
            return '<li>' + p.title + qtyLabel + (p.price ? ' : ' + formatMoney(p.price) : '') + '</li>';
          }).join('')
        + '</ul></span></div>';
    }
    els.summaryContent.innerHTML = html;
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!validateStep(5)) {
      showError('Veuillez remplir tous les champs obligatoires.');
      return;
    }
    var hp1 = document.getElementById('hp-website');
    var hp2 = document.getElementById('hp-company-url');
    if ((hp1 && hp1.value) || (hp2 && hp2.value)) return;
    var btn = document.getElementById('jgq-quote-submit');
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="jgq-ai-spinner" style="width:20px;height:20px;border-width:2px;display:inline-block;vertical-align:middle;margin-right:8px;"></span> Envoi en cours...';
    }
    var form = els.form;
    var data = new FormData(form);
    fetch(form.action, { method: 'POST', body: data })
      .then(function(r) {
        return r.json().then(function(res) {
          if (!r.ok || !res || !res.success) throw new Error((res && res.message) || 'Impossible d’envoyer votre demande.');
          return res;
        });
      })
      .then(function(res) { showThankYou(res); })
      .catch(function(error) {
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Envoyer ma demande';
        }
        showError(error.message || 'Impossible d’envoyer votre demande. Réessayez plus tard.');
      });
  }

  function showThankYou(res) {
    var wizard = document.getElementById('jgq-ai-wizard');
    if (!wizard) return;
    var estNum = res && res.data && res.data.estimate_number ? res.data.estimate_number : '';
    wizard.innerHTML = [
      '<div style="max-width:600px;margin:60px auto;text-align:center;padding:40px 24px;">',
      '  <div style="font-size:72px;margin-bottom:24px;">🎉</div>',
      '  <h2 style="font-family:var(--jgq-font-heading,Fredoka,sans-serif);font-size:2rem;color:var(--jgq-primary,#6c3bdb);margin-bottom:16px;">',
      '    Merci pour votre demande !',
      '  </h2>',
      '  <p style="font-size:1.1rem;color:#444;margin-bottom:12px;">',
      '    Votre soumission a bien été reçue.' + (estNum ? ' Votre numéro de dossier est <strong>' + estNum + '</strong>.' : ''),
      '  </p>',
      '  <p style="color:#666;margin-bottom:32px;">',
      '    Notre équipe vous contactera <strong>dans les 24 heures</strong> pour confirmer les détails et finaliser votre réservation.',
      '  </p>',
      '  <div style="background:linear-gradient(135deg,#f0ebff,#e8f4fd);border-radius:16px;padding:24px;margin-bottom:32px;text-align:left;">',
      '    <p style="margin:0 0 8px;font-weight:600;color:#333;">📋 Ce que nous allons faire :</p>',
      '    <ul style="margin:0;padding-left:20px;color:#555;line-height:2;">',
      '      <li>Vérifier la disponibilité de vos jeux pour les dates choisies</li>',
      '      <li>Préparer votre soumission personnalisée</li>',
      '      <li>Vous envoyer une confirmation par courriel</li>',
      '    </ul>',
      '  </div>',
      '  <p style="font-size:13px;color:#999;">Des questions ? Appelez-nous au <a href="tel:4186274348" style="color:var(--jgq-primary,#6c3bdb);">(418) 627-4348</a> ou écrivez-nous à <a href="mailto:bonheur@jeugonflablequebec.ca" style="color:var(--jgq-primary,#6c3bdb);">bonheur@jeugonflablequebec.ca</a></p>',
      '</div>'
    ].join('');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function setupAutocomplete() {}

  function formatMoney(n) {
    if (n == null || isNaN(n)) return 'Sur demande';
    try { return new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD' }).format(n); }
    catch(e) { return n + ' $'; }
  }

  function debounce(fn, ms) {
    var t;
    return function() {
      var a = arguments, c = this;
      clearTimeout(t);
      t = setTimeout(function() { fn.apply(c, a); }, ms);
    };
  }

  window.JGQ = {
    toggleProduct: toggleProduct,
    toggleForfait: toggleForfait,
    init: init,
    closeConsommablesModal: closeConsommablesModal,
    confirmConsommables: confirmConsommables,
    modalToggleItem: modalToggleItem,
    modalChangeQty: modalChangeQty
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
